import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { meanBy, toLower } from 'lodash';

import { getLocaleWithRegion } from '@gn-audio/jss-core/common/utilities';

import { fetchReviewsWithNext } from 'api/reviewsApi';
import { JabraStarRating } from 'common/components/JabraStarRating';
import { useAsync } from 'utils/hooks/useAsync';
import useFallbackTranslation from 'utils/hooks/useFallbackTranslation';

interface ProductReviewsProps {
  familyId?: number;
}
export const ProductReviews = ({ familyId }: ProductReviewsProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const language = getLocaleWithRegion(sitecoreContext.language);
  const reviews = useAsync(fetchReviewsWithNext, []);
  const { t } = useFallbackTranslation();

  let currentProductReviews = (reviews ?? []).filter(
    (review) => review.familyId === familyId && toLower(review.language) === toLower(language)
  );

  const hasAnyReviews = currentProductReviews.length > 0;

  if (!hasAnyReviews) return null;

  const avgRate = meanBy(currentProductReviews, (review) => review.rate);

  return (
    <div className="flex w-full items-center gap-2 text-[1.125rem] text-gray-700">
      <span className="text-[1.75rem]">
        <JabraStarRating rating={avgRate} />
      </span>

      <span>{avgRate.toFixed(2)}/5</span>
      <span className="flex-1"></span>
      <span>
        (
        <span className="underline">
          {currentProductReviews.length}&nbsp;{t('system.Reviews')}
        </span>
        )
      </span>
    </div>
  );
};
